import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";

import { SkeletonContainer } from "../../common/components";

interface LensSourcesSkeletonContainerProps {
    loading: boolean;
    children: ReactNode;
}

export const LensSourcesSkeletonContainer: FC<LensSourcesSkeletonContainerProps> = ({ loading, children }) => (
    <SkeletonContainer loading={loading} height={500} className={skeletonStyle}>
        {children}
    </SkeletonContainer>
);

const skeletonStyle = css`
    margin-top: 20px;
`;
